<template>
	<article class="fitbit-report">
		<!-- 日付バー -->
		<h1 class="fitbit-report__title">
			<svg @click="reloadDate(-7)" class="fitbit-report__title--pre-week" width="20" height="20" viewBox="0 0 20 20" fill="none">
				<path d="M16 15.9999L10 10.0161L16 3.99994" stroke-width="2" />
				<path d="M9 15.9999L3 10.0161L9 3.99994" stroke-width="2" />
			</svg>
			<svg @click="reloadDate(-1)" class="fitbit-report__title--pre-date" width="20" height="20" viewBox="0 0 20 20" fill="none">
				<path d="M13 15.9999L7 10.0161L13 3.99994" stroke-width="2" />
			</svg>
			<span
				@click="reloadDate(0)"
				:class="[
					'fitbit-report__title--date',
					{ 'is-disabled': isDisabledDate }
				]"
			>
				{{ computedDate }}
			</span>
			<svg
				@click="reloadDate(1)"
				:class="[
					'fitbit-report__title--post-date',
					{ 'is-disabled': isDisabledNextDate }
				]"
				width="9"
				height="14"
				viewBox="0 0 9 14"
				fill="none"
			>
				<path d="M1 1.00006L7 6.98395L1 13.0001" stroke-width="2" />
			</svg>
			<svg
				@click="reloadDate(7)"
				:class="[
					'fitbit-report__title--post-week',
					{ 'is-disabled': isDisabledNextWeek }
				]"
				width="16"
				height="14"
				viewBox="0 0 16 14"
				fill="none"
			>
				<path d="M8 1.00006L14 6.98395L8 13.0001" stroke-width="2" />
				<path d="M1 1.00006L7 6.98395L1 13.0001" stroke-width="2" />
			</svg>
		</h1>
		<!-- /日付バー -->

		<!-- ローディング -->
		<transition name="fade">
			<div v-if="isLoading" class="fitbit-report__loading">
				<redraw-progress />
			</div>
		</transition>
		<!-- /ローディング -->

		<!-- Fitbitレポート-->
		<div class="fitbit-report__inner">
			<!-- 睡眠 -->
			<section class="fitbit-report__contents is-sleep">
				<h2 class="fitbit-report__subtitle">
					<span>睡眠</span>
					<svg @click="openModal('sleep')" width="20" height="20" viewBox="0 0 20 20" fill="none">
						<g clip-path="url(#clip0_534_5943)">
							<path d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z" fill="white" />
							<path d="M9.21436 5.73698V3.99823H10.9531V5.73698H9.21436ZM9.21436 15.8341V7.62577H10.9531V15.8341H9.21436Z" fill="#5B9DFA" />
						</g>
						<defs>
							<clipPath id="clip0_534_5943">
								<rect width="20" height="20" fill="white"/>
							</clipPath>
						</defs>
					</svg>
				</h2>
				<p v-if="computedSleep.errorMessage !== ''" class="fitbit-report__contents--error">{{ computedSleep.errorMessage  }}</p>
				<div class="fitbit-report__sleep-total">
					<svg width="31" height="31" viewBox="0 0 31 31" fill="none">
						<g clip-path="url(#clip0_534_5962)">
							<path d="M19.75 12.61C19.81 12.67 19.84 12.76 19.83 12.85L19.3 15.95C19.28 16.05 19.33 16.16 19.41 16.22C19.49 16.28 19.61 16.29 19.7 16.24L22.48 14.78C22.56 14.74 22.65 14.74 22.73 14.78L25.51 16.24C25.6 16.29 25.71 16.28 25.8 16.22C25.88 16.16 25.93 16.05 25.91 15.95L25.38 12.85C25.36 12.76 25.39 12.67 25.46 12.61L27.71 10.42C27.78 10.35 27.81 10.24 27.78 10.14C27.75 10.04 27.66 9.97 27.56 9.95L24.45 9.5C24.36 9.49 24.28 9.43 24.24 9.35L22.85 6.53C22.8 6.44 22.71 6.38 22.6 6.38C22.49 6.38 22.4 6.44 22.35 6.53L20.96 9.35C20.92 9.43 20.84 9.49 20.75 9.5L17.64 9.95C17.54 9.96 17.45 10.04 17.42 10.14C17.39 10.24 17.42 10.35 17.49 10.42L19.74 12.61H19.75Z" fill="#AB7DE7"/>
							<path d="M26.53 20.56C21.8 23.29 15.74 21.59 13.13 16.76C10.66 12.18 12.37 6.26 16.9 3.7C18.13 3.01 19.44 2.61 20.76 2.49C21.02 2.47 21.07 2.11 20.82 2.02C16.72 0.419999 11.93 0.679999 7.84997 3.16C1.32997 7.12 -1.08003 15.68 2.41997 22.46C6.29997 29.97 15.62 32.65 22.86 28.47C26.87 26.15 29.24 22.21 30.04 17.98C30.09 17.7 29.75 17.58 29.59 17.79C28.81 18.89 27.78 19.84 26.54 20.56H26.53Z" fill="#AB7DE7" />
						</g>
						<defs>
							<clipPath id="clip0_534_5962">
								<rect width="30" height="30" fill="white" transform="translate(0.5 0.5)"/>
							</clipPath>
						</defs>
					</svg>
					<p class="fitbit-report__sleep-total--time">
						<span v-show="computedSleep.total.hour"><span class="is-time">{{ computedSleep.total.hour }}</span><span class="is-unit">時間</span></span><span class="is-time">{{ computedSleep.total.minutes ? computedSleep.total.minutes : '--' }}</span><span class="is-unit">分</span>
					</p>
				</div>
				<div class="fitbit-report__sleep-time">
					<svg width="18" height="18" viewBox="0 0 18 18" fill="none">
						<g clip-path="url(#clip0_534_5965)">
							<path d="M8.99655 0C4.03603 0 0 4.03603 0 8.99655C0 13.9571 4.03603 17.9931 8.99655 17.9931C13.9571 17.9931 17.9931 13.9571 17.9931 8.99655C17.9931 4.03603 13.9571 0 8.99655 0ZM8.99655 15.8544C5.21579 15.8544 2.13875 12.7773 2.13875 8.99655C2.13875 5.21579 5.21579 2.14565 8.99655 2.14565C12.7773 2.14565 15.8544 5.22269 15.8544 9.00345C15.8544 12.7842 12.7773 15.8612 8.99655 15.8612V15.8544Z" fill="#4B4B4B" />
							<path d="M6.24377 12.7773C5.9678 12.7773 5.71253 12.6738 5.51935 12.4806C5.1192 12.0805 5.1192 11.432 5.51935 11.0318L8.07895 8.47221L8.05826 4.88463C8.05826 4.3189 8.5205 3.86355 9.07934 3.86355C9.63817 3.86355 10.1004 4.32579 10.1004 4.88463V9.30701L6.96129 12.4737C6.76811 12.6669 6.51284 12.7704 6.23687 12.7704L6.24377 12.7773Z" fill="#4B4B4B" />
						</g>
						<defs>
							<clipPath id="clip0_534_5965">
								<rect width="18" height="18" fill="white"/>
							</clipPath>
						</defs>
					</svg>
					<span>{{ computedSleep.total.duration }}</span>
				</div>
				<div class="fitbit-report__sleep-step">
					<h3 class="fitbit-report__sleep-step--title">睡眠段階</h3>
					<ul class="fitbit-report__sleep-step--list">
						<li class="fitbit-report__sleep-step--item is-wake">
							<p class="fitbit-report__sleep-step--circle">
								<svg>
									<circle class="is-base" cx="28" cy="28" r="25" fill="white" stroke="#DFECFF" stroke-width="5" />
									<circle :style="`stroke-dashoffset: ${computedSleep.wake.strokeDashoffset}`" :class="['is-line', { 'is-animation': computedSleep.isAnimation && computedSleep.wake.isAnimation }]" cx="28" cy="28" r="25" fill="white" stroke="#80B5FF" stroke-width="7" />
								</svg>
								<em>{{ computedSleep.wake.per }}<span class="is-unit">%</span></em>
							</p>
							<p class="fitbit-report__sleep-step--text">覚醒</p>
							<p class="fitbit-report__sleep-step--time">{{ computedSleep.wake.time }}</p>
						</li>
						<li class="fitbit-report__sleep-step--item is-rem">
							<p class="fitbit-report__sleep-step--circle">
								<svg>
									<circle class="is-base" cx="28" cy="28" r="25" fill="white" stroke="#DFECFF" stroke-width="5" />
									<circle :style="`stroke-dashoffset: ${computedSleep.rem.strokeDashoffset}`" :class="['is-line', { 'is-animation': computedSleep.isAnimation && computedSleep.rem.isAnimation }]" cx="28" cy="28" r="25" fill="white" stroke="#80B5FF" stroke-width="7" />
								</svg>
								<em>{{ computedSleep.rem.per }}<span class="is-unit">%</span></em>
							</p>
							<p class="fitbit-report__sleep-step--text">レム睡眠</p>
							<p class="fitbit-report__sleep-step--time">{{ computedSleep.rem.time }}</p>
						</li>
						<li class="fitbit-report__sleep-step--item is-light">
							<p class="fitbit-report__sleep-step--circle">
								<svg>
									<circle class="is-base" cx="28" cy="28" r="25" fill="white" stroke="#DFECFF" stroke-width="5" />
									<circle :style="`stroke-dashoffset: ${computedSleep.light.strokeDashoffset}`" :class="['is-line', { 'is-animation': computedSleep.isAnimation && computedSleep.light.isAnimation }]" cx="28" cy="28" r="25" fill="white" stroke="#80B5FF" stroke-width="7" />
								</svg>
								<em>{{ computedSleep.light.per }}<span class="is-unit">%</span></em>
							</p>
							<p class="fitbit-report__sleep-step--text">浅い眠り</p>
							<p class="fitbit-report__sleep-step--time">{{ computedSleep.light.time }}</p>
						</li>
						<li class="fitbit-report__sleep-step--item is-deep">
							<p class="fitbit-report__sleep-step--circle">
								<svg>
									<circle class="is-base" cx="28" cy="28" r="25" fill="white" stroke="#DFECFF" stroke-width="5" />
									<circle :style="`stroke-dashoffset: ${computedSleep.deep.strokeDashoffset}`" :class="['is-line', { 'is-animation': computedSleep.isAnimation && computedSleep.deep.isAnimation }]" cx="28" cy="28" r="25" fill="white" stroke="#80B5FF" stroke-width="7" />
								</svg>
								<em>{{ computedSleep.deep.per }}<span class="is-unit">%</span></em>
							</p>
							<p class="fitbit-report__sleep-step--text">深い眠り</p>
							<p class="fitbit-report__sleep-step--time">{{ computedSleep.deep.time }}</p>
						</li>
					</ul>
				</div>
				<div class="fitbit-report__sleep-efficiency">
					<h3 class="fitbit-report__sleep-efficiency--title">睡眠効率</h3>
					<p class="fitbit-report__sleep-efficiency--inner">
						<span id="js_sleep_efficiency_per" :class="['fitbit-report__sleep-efficiency--bar', { 'is-animation': computedSleep.isAnimation }]"><i :style="`width: ${computedSleep.efficiency.px}px;`" /></span>
						<em class="fitbit-report__sleep-efficiency--per">{{ computedSleep.efficiency.per }}<span class="is-unit">%</span></em>
					</p>
				</div>
			</section>
			<!-- /睡眠 -->

			<!-- 心拍 -->
			<section class="fitbit-report__contents is-heartbeat">
				<h2 class="fitbit-report__subtitle">
					<span>心拍</span>
					<svg @click="openModal('heartbeat')" width="20" height="20" viewBox="0 0 20 20" fill="none">
						<g clip-path="url(#clip0_534_5943)">
							<path d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z" fill="white" />
							<path d="M9.21436 5.73698V3.99823H10.9531V5.73698H9.21436ZM9.21436 15.8341V7.62577H10.9531V15.8341H9.21436Z" fill="#5B9DFA" />
						</g>
						<defs>
							<clipPath id="clip0_534_5943">
								<rect width="20" height="20" fill="white" />
							</clipPath>
						</defs>
					</svg>
				</h2>
				<p v-if="heartbeatReport.errorMessage !== ''" class="fitbit-report__contents--error">{{ heartbeatReport.errorMessage  }}</p>
				<div class="fitbit-report__heart-rate">
					<svg width="31" height="31" viewBox="0 0 31 31" fill="none">
						<path d="M15.5 28.9357C15.65 28.8714 15.7464 28.8179 16.0357 28.6357C24.0071 23.2786 30.5 18.0286 30.5 11.3857C30.5 5.30001 27.0179 1.96787 22.8071 2.05358C19.4214 2.05358 17.3429 3.59644 15.5 5.8893C13.6679 3.59644 11.5893 2.05358 8.19286 2.05358C3.98214 1.97858 0.5 5.31073 0.5 11.3964C0.5 18.0393 6.99286 23.2786 14.9643 28.6464C15.2643 28.8286 15.35 28.8822 15.5 28.9464V28.9357Z" fill="#FF7373" />
					</svg>
					<p class="fitbit-report__heart-rate--rate">
						<span class="is-rate">{{heartbeatReport.rate}}</span><span class="is-unit">bpm</span><span class="is-text">（安静時心拍数）</span>
					</p>
				</div>
				<p class="fitbit-report__heart-range">
					最大{{ heartbeatReport.max }}bpm ／ 最小{{ heartbeatReport.min }}bpm
				</p>
				<section class="fitbit-report__heart-chart">
					<h3 class="fitbit-report__heart-chart--title">心拍数グラフ</h3>
					<div class="fitbit-report__heart-chart--inner">
						<canvas class="fitbit-report__heart-chart--chart" id="js_lineChart"></canvas>
					</div>
				</section>
				<!-- /心拍 -->
			</section>
			<!-- /Fitbitレポート-->
		</div>

		<!-- お知らせ詳細モーダル -->
		<v-ons-modal :visible="isVisiableModal" animation="fade" animationOptions="{ duration: 0.2, timing: 'ease-in' }">
			<aside class="fitbit-report__modal">
				<h2 class="fitbit-report__modal--title">
					<svg @click="isVisiableModal = false" width="41" height="40" viewBox="0 0 41 40" fill="none">
						<g clip-path="url(#clip0_485_8710)">
							<path d="M9.5 9.72L10.1986 9.02138L31.4995 30.2798L30.8009 30.9785L9.5 9.72Z" fill="#1EBFBB"/>
							<path d="M9.5 30.324L30.8009 9.06554L31.4995 9.76416L10.1986 31.0226L9.5 30.324Z" fill="#1EBFBB"/>
						</g>
						<defs>
							<clipPath id="clip0_485_8710">
								<rect width="40" height="40" fill="white" transform="translate(0.5)"/>
							</clipPath>
						</defs>
					</svg>
					<span>{{ modalType === 'sleep' ? '睡眠' : '心拍' }}について</span>
				</h2>
				<div class="fitbit-report__modal--body">
					<ul v-if="modalType === 'sleep'">
						<li><em>睡眠時間</em><span>年齢とともに睡眠時間は短くなりますが、一般的に高齢者をのぞく大人は7～8時間の睡眠をとるのが良いとされています。</span></li>
						<li><em>睡眠段階</em><span>レム睡眠よりも脳の活動が少ない非急速眼球運動（ノンレム）には、浅い睡眠と深い睡眠の段階が含まれます。 深い睡眠期間は、一般に就寝直後に長く現れます。</span></li>
						<li><em>睡眠効率</em>布団に入っている時間に対する実際に寝ている時間の割合。成人の場合、良質な睡眠効率のスコアは85％以上と言われています。</li>
					</ul>
					<ul v-else>
						<li><em>安静時心拍数</em><span>安静にしている時の１分あたりの心拍数です。通常、安静時の心拍数は60～100 bpmですが、年齢やフィットネスレベルに応じて変動します。</span></li>
						<li><em>最大心拍数</em><span>心臓にかかる負荷が最大の時に、計測対象範囲内での１分あたりの心拍数の最大数値を指します。</span></li>
						<li><em>最小心拍数</em>計測対象範囲内の１分あたりの心拍数の最小数値を指します。</li>
						<li><em>心拍数グラフ</em>５分毎の心拍数データをグラフ（24h）に表しています。</li>
					</ul>
				</div>
			</aside>
		</v-ons-modal>
		<!-- /お知らせ詳細モーダル -->
	</article>
</template>

<script>
// Vuex
import { mapActions, mapGetters } from 'vuex'
import { SET_HEARTBEAT_DATA, SET_SLEEP_DATA } from '../../store/modules/fitbit/mutation-types'

// Compornents
import RedrawProgress from '@/components/Molecules/RedrawProgress'	// TODO: 今回こちらのローディングを使用するが、今後統一する場合はWebviewRedrawProgressを使用する

// ライブラリ
import Chart from 'chart.js/auto'
import moment from 'moment'
moment.locale('ja')

export default {
	name: 'FitbitReport',
	components: {
		RedrawProgress
	},
	data () {
		return {
			isLoading: false,
			sleepBarwidth: 0,
			isVisiableModal: false,
			modalType: 'sleep',
			heartbeatReport: {
				rate: 0,
				max: 0,
				min: 0,
				errorMessage: ''
			},
			lineChart: null,
			isDisabledDate: true,
			isDisabledNextDate: true,
			isDisabledNextWeek: true,
			isFirstView: true,
			targetDate: this.$route.query.date ? parseInt(this.$route.query.date) : moment().hours(0).minute(0).second(0).millisecond(0).unix()	// NOTE: URLパラメータに日付があればその日付を、なければ今日の日付を設定
		}
	},
	created () {
	},
	mounted () {
		// NOTE: プレミアム会員向けの機能だが、入口がプロフィール画面からなのでそちらで制御する。

		// 初期化
		this.init()
	},
	computed: {
		// map Vuex getters
		...mapGetters('common', ['userId', 'userToken']),
		...mapGetters('fitbit', ['sleepData', 'heartbeatData']),

		// 日付表示
		computedDate () {
			return this.isDisabledDate ? moment.unix(this.targetDate).format('YYYY年MM月DD日') : moment.unix(this.targetDate).format('YYYY年MM月DD日(ddd)')
		},

		// 睡眠データ
		computedSleep () {
			const DIAMETER = 50
			const circumference = DIAMETER * Math.PI
			const sleep = {
				efficiency: {
					per: '--',
					px: 0
				},
				total: {
					hour: 0,
					minute: '--',
					duration: '--～--'
				},
				wake: {
					per: '--',
					time: '--分',
					strokeDashoffset: circumference,
					isAnimation: false
				},
				rem: {
					per: '--',
					time: '--分',
					strokeDashoffset: circumference,
					isAnimation: false
				},
				light: {
					per: '--',
					time: '--分',
					strokeDashoffset: circumference,
					isAnimation: false
				},
				deep: {
					per: '--',
					time: '--分',
					strokeDashoffset: circumference,
					isAnimation: false
				},
				isAnimation: false,
				errorMessage: ''
			}
			const makeTimeString = minutes => {
				const hour = Math.floor(minutes / 60)
				const minute = minutes % 60
				return `${hour}時間${minute}分`
			}

			// 合計睡眠時間
			const sleepData = this.sleepData && this.sleepData.sleep ? this.sleepData.sleep : null
			const timeInBed = sleepData && sleepData.time_in_bed ? sleepData.time_in_bed : 0

			// 合計睡眠時間が0でない場合、処理する
			if (timeInBed) {
				// 睡眠効率
				if (sleepData.efficiency) {
					const efficiency = Math.round(sleepData.efficiency)
					const widthPx = this.sleepBarwidth * (efficiency / 100)
					sleep.efficiency = {
						per: efficiency,
						px: widthPx
					}
				}

				// 睡眠時間
				const totalHour = Math.floor(timeInBed / 60)
				const totalMinute = timeInBed % 60
				const startTime = sleepData.start_time ? moment(new Date(sleepData.start_time)).format('HH:mm') : '--'
				const endTime = sleepData.end_time ? moment(new Date(sleepData.end_time)).format('HH:mm') : '--'
				sleep.total = {
					hour: totalHour,
					minutes: totalMinute,
					duration: `${startTime}～${endTime}`
				}

				// サマリー
				if (sleepData.summary) {
					// 覚醒
					const wakeMinutes = sleepData.summary.wake && sleepData.summary.wake.minutes ? sleepData.summary.wake.minutes : 0
					if (wakeMinutes > 0) {	// データがある場合
						const wakePer = Math.round(wakeMinutes / timeInBed * 100)
						const wakeStrokeDashoffset = circumference - wakePer / 100 * circumference
						const wakeTime = makeTimeString(wakeMinutes)
						sleep.wake = {
							per: wakePer,
							time: wakeTime,
							strokeDashoffset: wakeStrokeDashoffset,
							isAnimation: !isNaN(wakeMinutes)
						}
					}

					// レム睡眠
					const remMinutes = sleepData.summary.rem && sleepData.summary.rem.minutes ? sleepData.summary.rem.minutes : 0
					if (remMinutes > 0) {	// データがある場合
						const remPer = Math.round(remMinutes / timeInBed * 100)
						const remStrokeDashoffset = circumference - remPer / 100 * circumference
						const remTime = makeTimeString(remMinutes)
						sleep.rem = {
							per: remPer,
							time: remTime,
							strokeDashoffset: remStrokeDashoffset,
							isAnimation: !isNaN(remMinutes) && remMinutes > 0
						}
					}

					// 浅い眠り
					const lightMinutes = sleepData.summary.light && sleepData.summary.light.minutes ? sleepData.summary.light.minutes : 0
					if (lightMinutes > 0) {	// データがある場合
						const lightPer = Math.round(lightMinutes / timeInBed * 100)
						const lightStrokeDashoffset = circumference - lightPer / 100 * circumference
						const lightTime = makeTimeString(lightMinutes)
						sleep.light = {
							per: lightPer,
							time: lightTime,
							strokeDashoffset: lightStrokeDashoffset,
							isAnimation: !isNaN(lightMinutes) && lightMinutes > 0
						}
					}

					// 深い眠り
					const deepMinutes = sleepData.summary.deep && sleepData.summary.deep.minutes ? sleepData.summary.deep.minutes : 0
					if (deepMinutes > 0) {	// データがある場合
						const deepPer = Math.round(deepMinutes / timeInBed * 100)
						const deepStrokeDashoffset = circumference - deepPer / 100 * circumference
						const deepTime = makeTimeString(deepMinutes)
						sleep.deep = {
							per: deepPer,
							time: deepTime,
							strokeDashoffset: deepStrokeDashoffset,
							isAnimation: !isNaN(deepMinutes) && deepMinutes > 0
						}
					}

					// 最初のみアニメーションをONにする
					sleep.isAnimation = this.isFirstView
				}
			}

			// sleepデータのなかに'--'の値を持つデータがあるかどうか判定
			const isSleepData = Object.values(sleep).some(value => {
				if (typeof value === 'object') {	// valueがオブジェクトの場合
					return Object.values(value).some(v => v === '--')
				} else {
					return value === '--'
				}
			})

			// ひとつでも欠損データがあればエラーメッセージを設定
			if (isSleepData) sleep.errorMessage = '睡眠データが十分ではありません'

			return sleep
		}
	},
	methods: {
		// map Vuex actions
		...mapActions('fitbit', [SET_SLEEP_DATA, SET_HEARTBEAT_DATA]),

		// 初期化
		init () {
			// tartgetDateが今日なら日付押下のボタンをdisabledにする
			const targetDate = moment.unix(this.targetDate).format('YYYY-MM-DD')
			// console.log('this.targetDate: ', this.targetDate)
			// console.log('targetDate: ', targetDate)
			this.isDisabledDate = moment().format('YYYY-MM-DD') === targetDate

			// tartgetDateが今日より未来の場合は次の日・週に遷移するボタンをdisabledにする
			this.isDisabledNextDate = moment().isBefore(moment(new Date(targetDate)).add(1, 'd'))
			this.isDisabledNextWeek = moment().isBefore(moment(new Date(targetDate)).add(7, 'd'))
			// リクエストAPI設定
			const SET_SLEEP_DATA = this.SET_SLEEP_DATA({
				user_id: this.userId,
				user_token: this.userToken,
				date: this.targetDate
			})
			const SET_HEARTBEAT_DATA = this.SET_HEARTBEAT_DATA({
				user_id: this.userId,
				user_token: this.userToken,
				date: this.targetDate
			})

			this.isLoading = true
			// NOTE: 本画面ではどちらかもしくは二つともAPIリクエストがエラーになっても表示したいが、Promise.allだとひとつ失敗したら全て失敗になるのでPromise.allSettledを使用する
			Promise.allSettled([SET_SLEEP_DATA, SET_HEARTBEAT_DATA]).then(res => {
				// console.log('sleepData: ', this.sleepData)
				// console.log('heartbeatData: ', this.heartbeatData)

				// エラーの場合、コンソールに表示する
				for (let i = 0, len = res.length; i < len; i++) {
					const resData = res[i]
					if (resData.status === 'rejected') console.log('Error: ', resData.reason)
				}

				this.sleepBarwidth = document.getElementById('js_sleep_efficiency_per') !== null ? document.getElementById('js_sleep_efficiency_per').clientWidth : 0
				this.setHeartbeatData()
				this.isLoading = false
			})
		},

		// 心拍数の描画データを作成するメソッド
		setHeartbeatData () {
			// グラフ描画コンテキスト取得
			const ctx = document.getElementById('js_lineChart')

			// 心拍データの整形
			const heartrate = this.heartbeatData && this.heartbeatData.heartrate ? this.heartbeatData.heartrate : { 'resting_heart_rate': '--', 'timelog': [] }
			const timelog = heartrate.timelog

			// NOTE: {time: '00:00:00', value: null}から{time: '23:59:00', value: null}までの5分おきのデフォルト配列データを作成
			const defaultArray = Array.from({ length: 24 * 60 / 5 }, (_, i) => i).map(i => {
				const hour = Math.floor(i / 12)
				const minute = i % 12 * 5
				const time = `${hour < 10 ? '0' + hour : hour}:${minute < 10 ? '0' + minute : minute}:00`
				return { time: time, value: null }
			})

			// NOTE: timelogとdefaultArrayをマージ
			let margeData = defaultArray
			margeData = defaultArray.map(data => {
				const index = timelog.findIndex(d => d.time === data.time)
				if (index !== -1) {
					return timelog[index]
				} else {
					return data
				}
			})

			// NOTE: グラフ用データ作成
			const labels = margeData.map(data => data.time)
			const datapoints = margeData.map(data => data.value)

			// 配列datapointsのnullを除いた最大値と最小値を取得
			const max = Math.max(...datapoints.filter(value => value !== null))
			const min = Math.min(...datapoints.filter(value => value !== null))

			// 心拍データの設定
			// NOTE: FitbitAPIから取れるmax、minのデータがチャートに表示されるデータと齟齬があるのでチャートで取れるデータを最大最小に設定する
			this.heartbeatReport.rate = heartrate.resting_heart_rate
			this.heartbeatReport.max = isFinite(max) ? max : '--'	// NOTE: maxがInfinityのときは--を設定
			this.heartbeatReport.min = isFinite(min) ? min : '--'	// NOTE: minがInfinityのときは--を設定
			if (timelog.length === 0 || heartrate.rate === '--' || heartrate.max === '--' || heartrate.min === '--') this.heartbeatReport.errorMessage = '心拍データが十分ではありません'	// ひとつでも欠損データがあればエラーメッセージを設定

			// ラインチャートの設定
			const data = {
				labels: labels,
				datasets: [
					{
						label: '',
						data: datapoints,
						borderColor: '#80B5FF',
						fill: false,
						pointRadius: 0,
						borderWidth: 1.5,
						tension: 0.4
					}
				]
			}

			const config = {
				type: 'line',
				data: data,
				options: {
					responsive: true,
					maintainAspectRatio: false,
					scales: {
						x: {
							ticks: {
								maxTicksLimit: 5,
								count: 5,
								// X軸ラベルは6時間刻みで最後は23：59にする
								callback: (value, index, values) => {
									if (index === 0 || index === 12 * 6 || index === 12 * 12 || index === 12 * 18) {
										return `${Math.floor(value / 12)}:00`
									} else if (index === values.length - 1) {
										return `${Math.floor(value / 12)}:59`
									}
								},
								maxRotation: 0,
								minRotation: 0,
								color: '#4C4C4C'
							},
							grid: {
								color: '#FFFFFF'
							}
						},
						y: {
							ticks: {
								count: 3,
								maxTicksLimit: 3,
								color: '#4C4C4C'
							},
							suggestedMin: this.heartbeatReport.min === '--' ? 0 : this.heartbeatReport.min,
							suggestedMax: this.heartbeatReport.max === '--' ? 100 : this.heartbeatReport.max
						}
					},
					plugins: {
						legend: {
							display: false
						},
						tooltip: {
							enabled: false
						}
					},
					animation: this.isFirstView
				}
			}

			// チャートのフォントを設定
			Chart.defaults.font.size = 10
			Chart.defaults.font.family = `'M+ C Type-1 (basic latin) Medium'`
			Chart.defaults.borderColor = '#DFECFF'

			// チャートの描画
			// eslint-disable-next-line no-unused-vars
			this.lineChart = new Chart(ctx, config)
		},

		// 日付を変更するメソッド
		reloadDate (day) {
			if (day === 0) {
				this.targetDate = moment().hours(0).minute(0).second(0).millisecond(0).unix()
			} else {
				this.targetDate = moment.unix(this.targetDate).add(day, 'd').unix()
			}
			this.isFirstView = false
			this.lineChart.destroy()
			this.init()
		},

		// モーダルを表示するメソッド
		openModal (type) {
			this.modalType = type
			this.isVisiableModal = true
		}
	}
}
</script>

<style lang="scss" scoped>
@import "../../assets/sass/variable";

// NOTE: デザインシステム外のため他での利用禁止
$font-size-9: 0.562rem;
$font-size-15: 0.937rem;
$font-size-32: 2rem;

$color-background: #EBEBEB;
$color-futbit-primary: #5B9DFA;
$color-futbit-border: #EBEBEB;
$color-enabled: #999999;
$color-disabled: #CCCCCC;
$color-error-text: #999999;

// 直径50pxの円周を持つSASS変数を定義
$circle-diameter: 50px;
$pi: 3.14159265359;
$circle-circumference: calc(#{$circle-diameter} * #{$pi});

$anumation-duration: 1s;

.fitbit-report {
	position: relative;
	font-family: $family-primary;
	color: $text-primary;

	&__title {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: $spacing-14 $spacing-10;
		margin: 0;
		background-color: $background-primary;
		font-family: $family-primary;

		&--date {
			display: flex;
			align-items: center;
			font-size: $font-size-14;
			font-weight: normal;

			&.is-disabled  {
				pointer-events: none;

				&::after {
					content: '今日';
					display: block;
					padding: 0 $spacing-6;
					margin: 0 0 0 $spacing-6;
					background-color: $primary;
					font-size: $font-size-9;
					color: $text-seconday;
					border-radius: $spacing-2;
				}
			}
		}

		& > svg path { stroke: $color-enabled; }

		&--post-date,
		&--post-week {
			&.is-disabled  {
				pointer-events: none;

				path { stroke: $color-disabled; }
			}
		}
	}

	&__subtitle {
		display: flex;
		align-items: flex-end;
		justify-content: space-between;
		padding: $spacing-6 $spacing-8 $spacing-6 $spacing-16;
		margin: 0;
		background-color: $color-futbit-primary;
		border-radius: $spacing-10 $spacing-10 0 0;
		font-family: $lp-family-primary;
		color: $_white;
		font-size: $font-size-15;
		font-weight: normal;
		line-height: $line-height-1;
	}

	&__inner {
		padding: $spacing-20 $spacing-20;
		background-color: $color-background;
	}

	&__contents {
		position: relative;
		padding: 0 0 $spacing-10;
		background-color: $background-primary;
		border-radius: $spacing-10;

		&.is-heartbeat { margin-top: $spacing-10; }

		&--error {
			margin: $spacing-14 auto 0;
			font-family: $lp-family-primary;
			text-align: center;
			font-size: $font-size-12;
			color: $color-error-text;
			line-height: $line-height-1;
		}
	}

	// 睡眠・心拍
	&__heart-rate,
	&__sleep-total {
		display: flex;
		align-items: center;
		justify-content: center;
		margin: $spacing-10 auto 0;

		&--rate,
		&--time {
			margin: 0;

			span {
				display: inline-block;
				margin-left: $spacing-2;
			}

			.is-time { font-size: $font-size-36; }
			.is-rate { font-size: $font-size-36; }
			.is-unit { font-size: $font-size-20; }
			.is-text { font-size: $font-size-12; }
		}
	}

	&__sleep-time,
	&__heart-range {
		padding: 0 0 $spacing-18;
		border-bottom: 1px solid $color-futbit-border;
		font-size: $font-size-16;
	}

	&__sleep-step,
	&__sleep-efficiency,
	&__heart-chart {
		&--title {
			margin: 0 auto;
			padding: $spacing-18 0 0 $spacing-20;
			text-align: left;
			font-family: $family-primary;
			font-size: $font-size-15;
			font-weight: normal;
		}
	}

	// 睡眠
	&__sleep-time {
		display: flex;
		align-items: center;
		justify-content: center;

		& > span { margin-left: $spacing-6; }
	}

	&__sleep-step {
		&--list {
			display: flex;
			align-items: center;
			justify-content: center;
			padding: 0;
			margin: 0;
			list-style: none;
		}

		&--item {
			position: relative;
			width: 25%;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
		}

		&--circle {
			position: relative;
			display: block;
			margin: 0;
			width: 58px;
			height: 58px;

			svg {
				display: block;
				width: 100%;
				height: 100%;
				transform: rotate(-90deg);

				circle {
					stroke-dasharray: $circle-circumference;
					stroke-linecap: round;

					&.is-line {
						stroke-dashoffset: 0;

						&.is-animation { animation: sleepPieChartAnimation $anumation-duration forwards; }
					}
				}
			}

			& > em {
				position: absolute;
				display: block;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				font-size: $font-size-16;
				font-style: normal;

				.is-unit { font-size: $font-size-10; }
			}
		}

		&--text {
			margin: $spacing-2 0 0;
			font-size: $font-size-12;
		}

		&--time {
			margin: 0;
			font-size: $font-size-12;
			color: $color-futbit-primary;
		}
	}

	&__sleep-efficiency {
		&--title { padding: $spacing-26 0 0 $spacing-20; }

		&--inner {
			display: flex;
			align-items: center;
			justify-content: center;
			padding: 0 $spacing-20;
			margin: 0;
		}

		&--bar {
			position: relative;
			display: block;
			width: 73.077%;
			height: $spacing-16;
			background-color: $color-futbit-border;

			i {
				position: absolute;
				display: block;
				top: 0;
				left: 0;
				width: 0px;
				height: 100%;
				background-color: $color-futbit-primary;
			}

			&.is-animation i { transition: width $anumation-duration ease-out; }
		}

		&--per {
			margin-left: $spacing-14;
			font-size: $font-size-32;
			color: $color-futbit-primary;
			font-style: normal;

			.is-unit { font-size: $font-size-16; }
		}
	}

	// 心拍
	&__heart-range {
		margin: 0 auto;
		text-align: center;
	}

	&__heart-chart {
		&--inner {
			padding: $spacing-10 $spacing-4 0;
			background-color: $background-primary;
		}

		&--chart {
			min-height: 168px;
		}
	}

	// ローディング
	&__loading {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		background: rgba($_black, 0.4);
		overflow: hidden;
		z-index: 9999;

		.redraw-progress {
			position: fixed;
			background: none;
			height: 100vh;
		}
	}

	// モーダル
	&__modal {
		overflow: scroll;
		width: 96%;
		max-width: 360px;
		margin: 0 auto;
		padding: $spacing-10 0 $spacing-18;
		background-color: $background-primary;
		border-radius: $spacing-10;
		font-family: $lp-family-primary;
		color: $text-primary;

		&--title {
			display: flex;
			align-items: center;
			margin: 0;
			padding: 0 $spacing-10 $font-size-10;
			font-family: $family-primary;
			font-weight: normal;
			font-size: $font-size-18;
			border-bottom: 1px solid $color-futbit-border;

			svg {
				width: 40px;
			}

			span {
				display: block;
				flex: 1;
				padding-right: $spacing-40;
				text-align: center;
			}
		}

		&--body {
			padding: $spacing-20 $spacing-18 0;
			font-size: $font-size-14;

			ul {
				padding: 0;
				margin: 0;
				list-style: none;
			}

			li {
				text-align: left;
				margin-top: $spacing-20;

				&:first-of-type { margin-top: 0; }
			}

			em  {
				color: $color-futbit-primary;
				font-family: $lp-family-tertiary;
				font-weight: 700;
				font-style: normal;

				&::after {
					content: '：';
				}
			}
		}
	}
}

// アニメーション
.fade-enter-active, .fade-leave-active {
	transition: opacity .2s;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}

@keyframes sleepPieChartAnimation {
  0% {
    stroke-dasharray: 0 $circle-circumference;
  }
  99.9%, to {
    stroke-dasharray: $circle-circumference $circle-circumference;
  }
}
</style>
